export const TEST_ID = 'serviceIntervalsModalPlaceholder';

export const SKELETON_LINES = 6;
